import allUrls from '@/utils/config'

// 关于我们
const aboutUsList = {
  path: '',
  cname: '关于我们',
  name: 'about',
  il8nName: 'navs.aboutUs',
  children: [
    {
      path: '',
      cname: '资讯中心',
      name: 'news_info',
      il8nName: 'modules.about.news_info',
      children: [
        {
          path: '/about/board',
          cname: '服务公告',
          name: 'board',
          il8nName: 'modules.about.news_infos.notice',
        },
        {
          path: '/about/news',
          cname: '新闻动态',
          name: 'news',
          il8nName: 'modules.about.news_infos.title',
        },
        {
          path: '/about/promotion',
          cname: '推广专区',
          name: 'promotion',
          il8nName: 'modules.about.news_infos.promotion',
        },
        // {
        //   path: '/consulting/queryDescription',
        //   cname: '查询说明',
        //   name: 'consulting-queryDescription',
        //   il8nName: 'modules.about.queryDescription',
        // },
      ],
    },
    {
      path: '',
      cname: '关于我们',
      name: 'intro',
      il8nName: 'modules.intro.title',
      children: [
        {
          path: '/about/intro/detail/about',
          cname: '关于顺丰',
          name: 'intro-detail-about',
          il8nName: 'modules.intro.menu.about',
        },
        {
          path: '/about/intro/detail/course',
          cname: '发展历程',
          name: 'intro-detail-course',
          hidden: { mb: false },
          il8nName: 'modules.intro.menu.course',
        },
        // {
        //   path: '/about/intro/detail/desire',
        //   cname: '公司愿景',
        //   name: 'intro-detail-desire',
        //   hidden: { mb: false },
        //   il8nName: 'modules.intro.menu.desire',
        // },
        {
          path: '/about/intro/detail/culture',
          cname: '公司文化',
          name: 'intro-detail-culture',
          hidden: { mb: false },
          il8nName: 'modules.intro.menu.culture',
        },
        {
          path: '/about/intro/detail/honor',
          cname: '公司荣誉',
          name: 'intro-detail-honor',
          hidden: { mb: false },
          il8nName: 'modules.intro.menu.honor',
        },
      ],
    },
    {
      path: '/about/careers',
      cname: '加入我们',
      name: 'joinUs',
      il8nName: 'modules.about.joinUs',
      children: [
        {
          path: '/about/careers',
          cname: '人才招聘',
          name: 'careers',
          il8nName: 'modules.about.careers',
        },
        {
          path: '/about/jobOpenings',
          cname: '招聘职位',
          name: 'jobOpenings',
          // hidden: { mb: false },
          il8nName: 'modules.about.job',
        },
      ],
    },
    {
      path: '/about/contact',
      cname: '联系我们',
      name: 'contact_us',
      il8nName: 'modules.about.relations',
      children: [
        // {
        //   path: '/about/contactForm',
        //   cname: '免费获取报价',
        //   name: 'contactForm',
        //   il8nName: 'modules.about.contactForm',
        // },
        {
          path: '/about/address',
          cname: '公司地址',
          name: 'address',
          il8nName: 'modules.about.contact.europeOfficeLocations',
        },
        {
          path: '/about/onlineChat',
          cname: '在线咨询',
          name: 'onlineChat',
          il8nName: 'modules.about.contact.inquirychat',
        },
        {
          path: '/about/contact',
          cname: '全球服务热线',
          name: 'contactUs',
          il8nName: 'modules.about.contact.hotLine',
        },    
        // {
        //   path: allUrls.iuopGlobalCustomerUrl,
        //   cname: '商务合作',
        //   name: 'businessCooperation',
        //   il8nName: 'modules.about.businessCooperation',
        // },
      ],
    },
    {
      path: allUrls.iuopGlobalCustomerUrl,
      cname: '商务合作',
      name: 'coop',
      il8nName: 'modules.about.businessCooperation',
    },
    // {
    //   path: '',
    //   cname: '咨询中心',
    //   name: 'consulting',
    //   il8nName: 'modules.about.consulting',
    //   children: [
    //     {
    //       path: '/consulting/queryDescription',
    //       cname: '查询说明',
    //       name: 'consulting-queryDescription',
    //       il8nName: 'modules.about.queryDescription',
    //     },
    //   ],
    // },
  ],
}

export default aboutUsList
